export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    }).catch(() => {
      // Ignore cleanup failures and let the app continue.
    });

    if ("caches" in window) {
      caches.keys().then((cacheKeys) => {
        cacheKeys.forEach((cacheKey) => {
          caches.delete(cacheKey);
        });
      }).catch(() => {
        // Ignore cache cleanup failures and let the app continue.
      });
    }
  });
}
